// @flow
import type { AxiosPromise, AxiosInstance } from "axios";

const getBookingsReceived = (
  page: number | string,
  filter: Array<string>,
  include?: Array<string> = [],
  perPage?: number | string = "7"
): ((apiInstance: AxiosInstance) => AxiosPromise) => (apiInstance) => {
  return apiInstance.get(`/v5/bookings/received`, {
    params: {
      include: [
        "driver_price",
        "vehicle",
        "driver",
        "space_owner_earnings",
        ...include
      ].join(","),
      page,
      per_page: perPage,
      status: filter
    }
  });
};

export default getBookingsReceived;
